export const DownloadsGetters = {
  visibleDownloadRequests: state => state.requests.filter(r => !!r.visible),
}
